// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2pcSQ","title":"Images45_title__2UXSY","images":"Images45_images__1GV1g"};